import { i18n } from "@/modules/App/components/i18n/i18n.client"
import { z } from "zod"

function getErrorMessage(key: string) {
  return i18n.t(`pet-name-errors.${key}`, {
    ns: "pet-name-page",
  })
}

export const petNameSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, getErrorMessage("min-length"))
    .max(256, getErrorMessage("max-length")),
})

export type PetNameSchema = z.infer<typeof petNameSchema>
